export const environment = {
  production: false,
  name: 'sandbox',
  apiUrl: 'https://api.airgateway.net/',
  keycloakUrl: 'https://auth.airgateway.net',
  tracerUrl: 'https://tracer-api.airgateway.net',
  bpUrl: 'https://web.bookingpad.net/',
};
